var _style, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkPinkSphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3.9 3.9",
    style: {
      enableBackground: "new 0 0 3.9 3.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 2.448,
    cy: 1.4063,
    r: 2.7057,
    fx: 3.3222,
    fy: 0.6584,
    gradientTransform: "matrix(1 0 0 0.9308 0 9.737101e-02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#D810B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4495,
    style: {
      stopColor: "#9F0F95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    style: {
      stopColor: "#480D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#250C57"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1.9,
    cy: 1.9,
    r: 1.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPinkSphere);
export default __webpack_public_path__ + "static/media/dark-pink-sphere.e47d562eb72431028e81c24862e79eb8.svg";
export { ForwardRef as ReactComponent };